# "Does a reader in this locale get the AUTHORED text?" — one rule, shared by
# the server (framework/localeTargets.coffee) and the browser (i18nManager).
#
# The rule itself was decided 2026-07-19 (translation control overhaul):
#   exact locale → a supported variant of the same base language → source.
# A requested locale whose base language matches the source's base, and that
# is not itself a supported target, reads the source. So with the default
# source en-US, an en-US or en-CA reader gets the authored React text, while
# en-GB — once an admin lists it in TRANSLATE_LOCALES — reads its own
# translation. Dialects are never collapsed into the source by fiat.
#
# WHY THE BROWSER NEEDS IT (card 6aa6c73847c945dd8596e7d9). The client used to
# spell "is this English" as `locale == 'en'`. A browser reports 'en-US', so
# every ordinary English visitor took the translated path: fetched the whole
# i18nString catalogue (which the server answers with the English source,
# since en-US resolves to it), cached ~700 strings mapped to themselves, and
# rendered every stamped element through i18nCreateElement's substitution
# branch. The client now asks this rule instead of comparing to a literal.
#
# `config` is what the instance publishes in its /clientapi manifest:
#   {sourceLocale, supportedLocales}
# and, server-side only, `isKnown` (membership in shared/locales.json — 1.2MB,
# far too large to ship to a browser). Without `isKnown` an unrecognised code
# is treated as real; the only effect is that a garbage code the server would
# resolve to the source may still fetch the catalogue, which is the old
# behaviour, never a translation withheld.

DEFAULT_SOURCE = 'en-US'

baseLang = (code) -> String(code or '').split('-')[0].toLowerCase()

resolveReadLocale = (requested, config = {}) ->
  src = config.sourceLocale or DEFAULT_SOURCE
  supported = config.supportedLocales or []
  return src unless requested
  return src if config.isKnown? and not config.isKnown(requested)
  return requested if requested is src
  return requested if requested in supported
  return src if baseLang(requested) is baseLang(src)
  sibs = (c for c in supported when baseLang(c) is baseLang(requested)).sort()
  return sibs[0] if sibs.length > 0
  src

# The browser's question. When the instance has not told us its settings (an
# older server, or a page with no manifest such as the SSR component runtime)
# we cannot know which dialects are supported, so only the source itself and
# its bare base language ('en') count as the source — everything else keeps
# the old fetch-and-translate path rather than risk hiding a translation.
readsSource = (locale, config) ->
  if config?.sourceLocale?
    return resolveReadLocale(locale, config) is config.sourceLocale
  return true unless locale
  locale is DEFAULT_SOURCE or locale is baseLang(DEFAULT_SOURCE)

module.exports = {resolveReadLocale, readsSource, baseLang, DEFAULT_SOURCE}
